//@flow
import { call, put, takeLatest, all } from "redux-saga/effects";
import { navigate } from "../navigation/navigatorHelper";

import {
  FEELING_SUBMIT_REQUESTING,
  FEELING_SUBMIT_ERROR,
  FEELING_SUBMIT_SUCCESS,
  FEELING_GET_ONBOARDING_STATS_REQUESTING,
  FEELING_GET_ONBOARDING_STATS_SUCCESS,
  FEELING_GET_ONBOARDING_STATS_ERROR,
} from "./constants";

import { fetchApi } from "../api";
import { AlertType, showAlert } from "../profileSettings/actions";
import i18n from "../../i18n";
import { getUserRequest } from "../user/actions";

const endPoints = {
  submitFeeling: "/v1/users/submit-feeling",
  getOnboardingStats: "/v1/clients/onboarding-stats/",
};

const submitFeelingApi = data => {
  return fetchApi(endPoints.submitFeeling, data, "post");
};

const getOnboardingStatsApi = data => {
  return fetchApi(endPoints.getOnboardingStats + data, {}, "get");
};

function* submitFeelingSaga(action) {
  try {
    const response = yield call(submitFeelingApi, action.payload);

    yield put({
      type: FEELING_SUBMIT_SUCCESS,
      payload: action.payload.feeling,
    });
    yield put(
      showAlert({
        title: i18n.t("feeling-evolution-title-success"),
        message: i18n.t("feeling-evolution-message-success"),
        alertType: AlertType.SUCCESS,
      }),
    );

    navigate("Main");
  } catch (error) {
    yield put({ type: FEELING_SUBMIT_ERROR });
    console.log(error);
  }
}

function* getOnboardingStatsFlow(action) {
  try {
    const response = yield call(getOnboardingStatsApi, action.payload.clientId);
    yield put({
      type: FEELING_GET_ONBOARDING_STATS_SUCCESS,
      payload: response,
    });
  } catch (error) {
    yield put({ type: FEELING_GET_ONBOARDING_STATS_ERROR });
    console.log(error);
  }
}

function* trackWatcher() {
  yield all([
    takeLatest(FEELING_SUBMIT_REQUESTING, submitFeelingSaga),
    takeLatest(FEELING_GET_ONBOARDING_STATS_REQUESTING, getOnboardingStatsFlow),
  ]);
}

export default trackWatcher;
